export default "__VITE_ASSET__BeenWBrf__"